import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-sm-8" }
const _hoisted_2 = { class: "col-sm-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_list = _resolveComponent("select-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_select_list, {
        ref: "monthList",
        label: _ctx.monthLabel,
        "aria-label": _ctx.ariaMonthLabel,
        items: _ctx.getMonths(),
        onChange: _ctx.onMonthChange,
        class: "mb-4 mb-sm-0"
      }, null, 8, ["label", "aria-label", "items", "onChange"])
    ], 512), [
      [_vShow, _ctx.mode == _ctx.MonthYearDisplayMode.MonthAndYear]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_select_list, {
        ref: "yearList",
        label: _ctx.yearLabel,
        "aria-label": _ctx.ariaYearLabel,
        items: _ctx.getYears,
        onChange: _ctx.onYearChange
      }, null, 8, ["label", "aria-label", "items", "onChange"])
    ])
  ], 64))
}